import { useQuery } from '@tanstack/react-query'
import { fetcher } from 'repositories/BerthApi/berthApiClient'
import { getBookingMasterDataEndpoint } from 'repositories/BerthApi/getBookingMasterData/endpoint'
import type {
  BookingMasterData,
  GetBookingMasterDataResponse,
} from 'repositories/BerthApi/getBookingMasterData/type'
import { bookingKeys } from 'repositories/queryKeys'

export type { BookingMasterData }

export function useBookingMasterData(tenantId: string | null) {
  const key = tenantId ? getBookingMasterDataEndpoint(tenantId) : null

  const { data, error, isLoading } = useQuery<GetBookingMasterDataResponse>({
    queryKey: bookingKeys.masterDataByTenant(tenantId ?? ''),
    queryFn: () => fetcher(key!),
    enabled: !!key,
  })

  return {
    masterData: data?.data ?? null,
    isLoading,
    error,
  }
}
